import { GetRouteData } from '@folx-types/flow';

import CURRENT_MEMBER_WITH_ADDRESSES from '@graphql/queries/currentMemberWithAddresses.gql';

export const onboardingQuery = CURRENT_MEMBER_WITH_ADDRESSES;

export const onboardingRouteData: GetRouteData = (flowData, queryData) => {
	let existingFormData = flowData;

	const { currentMember } = queryData ?? {
		currentMember: {},
	};
	const addresses = queryData?.addresses?.nodes;
	existingFormData = {
		...{
			stateOfResidence: currentMember?.stateOfResidence ?? undefined,
			legalFirstName: currentMember?.legalFirstName ?? undefined,
			legalLastName: currentMember?.legalLastName ?? undefined,
			preferredFirstName:
				currentMember?.affirmingFirstName ?? currentMember?.legalFirstName ?? undefined,
			preferredLastName:
				currentMember?.affirmingLastName ?? currentMember?.legalLastName ?? undefined,
			legalSex: currentMember?.legalGender ?? undefined,
			phone: currentMember?.smsNumber ?? undefined,
			dob: currentMember?.dob ?? undefined,
			pronouns: currentMember?.preferredPronouns ?? undefined,
		},
		...existingFormData,
		...(currentMember?.email && {
			email: currentMember.email,
		}),
	};
	if (addresses?.length > 0) {
		existingFormData = {
			...{
				shippingAddressLine1: addresses[0].line1 ?? undefined,
				shippingAddressLine2: addresses[0].line2 ?? undefined,
				shippingCity: addresses[0].city ?? undefined,
				shippingState: addresses[0].state ?? undefined,
				shippingZip: addresses[0].zip ?? undefined,
			},
			...(addresses[0].shippingFirstName === existingFormData.preferredFirstName &&
			addresses[0].shippingLastName === existingFormData.preferredLastName
				? {
						shippingNameIsDifferent: false,
				  }
				: {
						shippingFirstName: addresses[0].shippingFirstName ?? undefined,
						shippingLastName: addresses[0].shippingLastName ?? undefined,
				  }),
			...existingFormData,
		};
	}

	return existingFormData;
};
